export default function checkExtraGuests(guestCount, nights) {
  if (guestCount <= 3) {
    return false;
  }

  const extraGuests = guestCount - 3;
  const totalCharge = extraGuests * 100 * nights;

  return {
    extraGuests,
    totalCharge,
  };
}
